  import React, { useEffect, useState } from "react";

  const Sections = ({
    data,
    columns,
    downloadFileName,
    dateFrom,
    dateTo,
    actions,
  }) => {

    const [dataShow, setDataShow] = useState(false);

    useEffect(() => {
        if(data){
            setDataShow(true)
        }        
    },[data])


    // const isNumber = (value) => Number.isFinite(value);

    const isNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }

  return Number.isFinite(Number(value));
};

    const toNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

    const formatNumber = (value) => {
  return toNumber(value).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

    return (
    <div className="ez-table-wrapper" style={{backgroundColor:"#ffffff",borderRadius:"5px"}}>
    <table>
      {columns ? (
        <thead>
          <tr>
            {columns.map((item, index) => (
              <th className="trow" key={index}>
                {isNumber(item.label) ? formatNumber(item.label) : item.label}
              </th>
            ))}
          </tr>
        </thead>
      ) : (
        ""
      )}

{dataShow ? (
            <tbody>
              {data
                .map((item, index) => (
                  <tr key={`tr-item-${index}`}>
                    {columns.map((col, _index) => (
                      <td
                        key={`td-row-${index}-col-${_index}`}
                        className={
                          "text-align-" +
                          (col.hasOwnProperty("options")
                            ? col.options.align ?? "left"
                            : "left")
                        }
                      >
                        {isNumber(col.name) ? formatNumber(item[col.name]) :(item[col.name] ?? "")}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          ) : null}
      </table>
      </div>
    );
  }
  export default Sections;